// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Text,
//   Spinner,
//   Badge,
// } from '@chakra-ui/react';
// import axios from 'axios';

// const ReviewRating = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchRatings = async () => {
//     try {
//       const token =
//         localStorage.getItem('adminToken') || localStorage.getItem('token');
//       if (!token) {
//         throw new Error('Admin token missing from localStorage');
//       }

//       const res = await axios.get(
//         'http://localhost:4000/api/admin/all-ratings',
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       setData(res.data.data);
//     } catch (error) {
//       console.error('Error fetching ratings', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRatings();
//   }, []);

//   return (
//     <Box p="20px">
//       <Text fontSize="2xl" fontWeight="bold" mb="20px">
//         Review & Ratings
//       </Text>

//       {loading ? (
//         <Spinner size="xl" />
//       ) : (
//         <Table variant="simple">
//           <Thead>
//             <Tr>
//               <Th>User</Th>
//               <Th>Email</Th>
//               <Th>Rating</Th>
//               <Th>Review</Th>
//               <Th>Type</Th>
//               <Th>Target</Th>
//               <Th>Date</Th>
//             </Tr>
//           </Thead>

//           <Tbody>
//             {data.map((item) => (
//               <Tr key={item._id}>
//                 <Td>{item.user?.name}</Td>
//                 <Td>{item.user?.email}</Td>

//                 <Td>
//                   <Badge colorScheme="green">{item.rating} ⭐</Badge>
//                 </Td>

//                 <Td>{item.review || '—'}</Td>

//                 <Td>
//                   <Badge colorScheme="purple">{item.targetType}</Badge>
//                 </Td>

//                 <Td>{item.targetName}</Td>

//                 <Td>{new Date(item.createdAt).toLocaleDateString()}</Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//       )}
//     </Box>
//   );
// };

// export default ReviewRating;



/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Spinner,
  Badge,
  Input,
  Flex,
} from '@chakra-ui/react';
import axios from 'axios';

const ReviewRating = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const fetchRatings = async () => {
    try {
      const token =
        localStorage.getItem('adminToken') || localStorage.getItem('token');

      const res = await axios.get(
        `${(process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/')}api/admin/all-ratings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setData(res.data.data || []);
      setFilteredData(res.data.data || []);
    } catch (error) {
      console.error('Error fetching ratings', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRatings();
  }, []);

  // ✅ SEARCH FILTER
  useEffect(() => {
    const filtered = data.filter((item) =>
      `${item.user?.name} ${item.user?.email} ${item.targetName}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );

    setFilteredData(filtered);
  }, [search, data]);

  return (
    <Box pt={{ base: '130px', md: '90px', xl: '90px' }} px="20px">
      {/* Header + Search */}
      <Flex justify="space-between" align="center" mb="20px">
        <Text fontSize="2xl" fontWeight="bold">
          Review & Ratings
        </Text>

        <Input
          placeholder="Search user / email / target..."
          width="300px"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Flex>

      {loading ? (
        <Spinner size="xl" />
      ) : (
        <Box overflowX="auto">
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>User</Th>
                <Th>Email</Th>
                <Th>Rating</Th>
                <Th>Review</Th>
                <Th>Type</Th>
                <Th>Target</Th>
                <Th>Date</Th>
              </Tr>
            </Thead>

            <Tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <Tr key={item._id}>
                    <Td>{item.user?.name}</Td>
                    <Td>{item.user?.email}</Td>

                    <Td>
                      <Badge colorScheme="green">
                        {item.rating} ⭐
                      </Badge>
                    </Td>

                    <Td maxW="200px">
                      {item.review || '—'}
                    </Td>

                    <Td>
                      <Badge colorScheme="purple">
                        {item.targetType}
                      </Badge>
                    </Td>

                    <Td>{item.targetName}</Td>

                    <Td>
                      {new Date(item.createdAt).toLocaleDateString()}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="7" textAlign="center">
                    No Results Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default ReviewRating;
